import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import WorkPageHeader from '../../components/work/WorkPageHeader';
import { Card } from 'antd';
import { PartitionOutlined } from '@ant-design/icons';
import SubDepartmentsCard from '../../components/live-chat/SubDepartmentsCard';

const LiveChatSubDepartments = () => (
  <MainLayout>
    <div style={{ fontFamily: 'CustomFont' }}>
      <Card className="shadow-xl border-0 work-page-card" styles={{ body: { padding: 0 } }}>
        <WorkPageHeader title="زیربخش‌ها" subtitle="مدیریت زیربخش‌های پاسخ‌گویی" icon={PartitionOutlined} />
        <div className="px-6 pb-6 work-page-body rounded-b-xl">
          <SubDepartmentsCard />
        </div>
      </Card>
    </div>
  </MainLayout>
);

export default LiveChatSubDepartments;
